import React, { useState } from "react";
import { motion } from "framer-motion";
import Clicksound from "../assets/clicksound.mp3";
import { Howl, Howler } from "howler";
import { smashData } from "./data/smashData";
import { menuData } from "./data/menuData";

//SVG
import { ReactComponent as Close } from "../assets/close.svg";

export default function Modal(props) {
  const { activeObject, setShowNotice, setShowModal, onAdd, useClickOutside } =
    props;

  const [selectedVariant, setSelectedVariant] = useState(null);

  const sound = new Howl({ src: Clicksound });
  Howler.volume(0.2);

  const variants =
    activeObject.isBaseVariant && !activeObject.servingGroup
      ? smashData.filter(
          (item) =>
            item.type === activeObject.type && item.category === "burger",
        )
      : null;

  const servingVariants = activeObject.servingGroup
    ? menuData.filter((item) => item.servingGroup === activeObject.servingGroup)
    : null;

  const displayProduct =
    selectedVariant || (variants || servingVariants ? null : activeObject);

  const domNode = useClickOutside(() => {
    setShowModal(false);
  });

  return (
    <>
      <motion.div
        transition={{ duration: 0.2 }}
        className="productModal"
        ref={domNode}
      >
        <span className="close" onClick={() => setShowModal(false)}>
          <Close />
        </span>
        <div className="product-img-holder">
          <img
            src={selectedVariant ? selectedVariant.image : activeObject.image}
            alt="img"
          />
        </div>
        <div className="product-details">
          <span className="list-title">
            {selectedVariant ? selectedVariant.name : activeObject.name}
          </span>
          <span className="list-grams">
            {selectedVariant ? selectedVariant.grams : activeObject.grams}
          </span>
          <span className="list-price">
            {selectedVariant
              ? selectedVariant.price
              : variants || servingVariants
                ? "—"
                : activeObject.price}{" "}
            рсд
          </span>
          <span className="list-desc">
            {selectedVariant ? selectedVariant.desc : activeObject.desc}
          </span>

          {variants && (
            <div className="variant-selector">
              <span className="variant-label">Izaberi veličinu:</span>
              <div className="variant-options">
                {variants.map((v) => (
                  <button
                    key={v.id}
                    className={`variant-btn${selectedVariant?.id === v.id ? " active" : ""}`}
                    onClick={() => setSelectedVariant(v)}
                  >
                    <span className="variant-btn-name">{v.variantLabel}</span>
                    <span className="variant-btn-price">{v.price} рсд</span>
                  </button>
                ))}
              </div>
            </div>
          )}

          {servingVariants && (
            <div className="variant-selector">
              <span className="variant-label">Изабери начин послуживања:</span>
              <div className="variant-options">
                {servingVariants.map((v) => (
                  <button
                    key={v.id}
                    className={`variant-btn${selectedVariant?.id === v.id ? " active" : ""}`}
                    onClick={() => setSelectedVariant(v)}
                  >
                    <span className="variant-btn-name">{v.servingLabel}</span>
                    <span className="variant-btn-price">{v.price} рсд</span>
                  </button>
                ))}
              </div>
            </div>
          )}

          <span className="list-cart fancy-link">
            <button
              disabled={
                (variants && !selectedVariant) ||
                (servingVariants && !selectedVariant)
              }
              onClick={() => {
                if (
                  (variants && !selectedVariant) ||
                  (servingVariants && !selectedVariant)
                )
                  return;
                onAdd(displayProduct);
                setShowNotice(true);
                sound.play();
              }}
            >
              <span data-hover="Додајте у корпу">Додајте у корпу</span>
            </button>
          </span>
        </div>
      </motion.div>

      {setShowModal ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
          className="productOverlay"
        ></motion.div>
      ) : null}
    </>
  );
}
